// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getChosenVariant } from '../../../ab-test/utils';
import CheckoutStepContainer from '../containers/CheckoutStepContainer';
import CheckoutStepVariantContainer from '../containers/CheckoutStepVariantContainer';

import type { Match } from '../../../../router';

type Props = {
  +chosenVariants?: { [key: string]: number };
  +match: Match;
  +location: Location;
};

export default class CheckoutStepProxy extends Component<Props> {

  render() {
    const { chosenVariants, match, location } = this.props;
    return <CheckoutStepVariantContainer match={match} location={location}/>;
    /*const chosenVariant = getChosenVariant(chosenVariants, 'mostEffectiveCheckoutStep');
    return (!!chosenVariant.index ?
        <CheckoutStepVariantContainer match={match} location={location}/> :
        <CheckoutStepContainer match={match} location={location}/>
    )*/
  }

}

CheckoutStepProxy.propTypes = {
  chosenVariants: PropTypes.object,
  match: PropTypes.object.isRequired,
  location: PropTypes.object,
}




// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/CheckoutStepProxy.jsx